import React, { useEffect, useState } from 'react';
import { HiArrowUp } from 'react-icons/hi';
import './back-to-top.css';

function BackToTop() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const toggleVisible = () => setVisible(document.documentElement.scrollTop > 600);
        window.addEventListener('scroll', toggleVisible, { passive: true });
        return () => window.removeEventListener('scroll', toggleVisible);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <div
            style={{ display: visible ? 'block' : 'none' }}
            className='backToTop'
        >
            <button type='button' onClick={scrollToTop} aria-label='Back to top'>
                <HiArrowUp aria-hidden='true' />
            </button>
        </div>
    );
}

export default BackToTop;
